import extendNode from '../extendNode.mjs'
import openWindow from '@/script/openWindow.mjs'
import useProductNode from '../_PRODUCT/useProductNode.jsx'
import meta from './metaArchNode.mjs'

export default () => {
    const ProductNode = useProductNode()

    return extendNode(ProductNode, {
        ...meta,

        canChangeVersion(map, node) {
            if ('SA_MAP' === map.data.mapTypeCode) {
                return true
            }
            else {
                return ProductNode.canChangeVersion.call(this, map, node)
            }
        },

        canDeleteTree(map, node) {
            if ('SA_MAP' === map.data.mapTypeCode) {
                return false
            }
            else {
                return ProductNode.canDeleteTree.call(this, map, node)
            }
        },

        canMountType(map, node, type) {
            return (
                this.moduleType === type ||
                ProductNode.canMountType.call(this, map, node, type)
            )
        },

        canMove(map, node) {
            return false
        },

        getText(map, node) {
            if ('SA_MAP' === map.data.mapTypeCode) {
                // 总图节点显示别名；个别项目子类型（如需求模型B）可通过 aliasBySubType 覆盖
                return this.aliasBySubType?.[map.data.subTypeCode] ?? this.alias
            }
            else {
                return ProductNode.getText.call(this, map, node)
            }
        },

        getDesc(map, node) {
            return ''
        },

        menuItemsInsertConcept(map, node) {
            return [
                {type: this.moduleType},
            ]
        },

        async onDoubleClick(map, node, event) {
            event.preventDefault()
            const {prjId, prjNo, rev, sVer} = node.data
            const target = event.altKey ? '_self' : '_blank'
            openWindow(this.archUrl, {prjId, prjNo, rev, sVer}, target)
        },

        //showVersion(map, node) {
            //return false
        //},

        _fixChild(map, node, child) {
            return map.BizNode[this.moduleType]._fixChild(map, node, child)
        },

        async _readGrowTree(map, node) {
            const {pkid} = node.data
            let {rev} = node.data

            if (! rev) {
                const arch = await this.read({pkid})
                rev = arch.rev
            }

            if (! rev) {
                const name = this.typeName(map, node.parent)
                throw new Error(`请先发布${name}`)
            }

            return this.readTree({pkid, rev})
        },
    })
}
